import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  api,
  dateFormat,
  priceFormat,
  paymentMethodFormatter,
} from '@cashew/utils';
import Pagination from '@cashew/pagination';
import Modal from '@cashew/modal';
import cn from 'classnames';

import { Box, List } from '../../../components';

import './index.css';

interface OptionHistory {
  storeId: string;
  subProductType: string;
  isVisible: boolean;
  onClose: () => void;
}

const ns = 'payment-option-item';
const nsModal = 'history-modal';

const currencyCode = 'AED';

const PaymentHistoryItem = ({
  data: { orderCashewFee, serviceFeePercentage, startDate },
}: any) => (
  <div className={cn(ns)}>
    <div>
      {priceFormat({
        currency: currencyCode,
        amount: orderCashewFee,
      })}
    </div>
    <div>{`${serviceFeePercentage}%`}</div>
    <div>{!startDate ? '' : dateFormat({ date: startDate })}</div>
  </div>
);

export default ({
  onClose,
  isVisible,
  storeId,
  subProductType,
}: OptionHistory) => {
  const { t } = useTranslation();
  const { token } = useSelector((state: any) => state.user);

  const [loading, setLoading] = useState(false);

  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [historyList, setHistoryList] = useState([]);

  const getPaymentHistory = () => {
    if (!subProductType) {
      return;
    }
    const params: any = {
      storeId,
      subProductType,
      size: pageSize,
      page: pageNumber,
    };
    setLoading(true);
    api
      .get({
        endpoint: 'stores/service-fee/history',
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        setHistoryList(res.data);
        setRecords(res.totalCount);
      })
      .catch((err: any) => console.log(err))
      .finally(() => setLoading(false));
  };
  useEffect(
    () => getPaymentHistory(),
    [subProductType, storeId, pageSize, pageNumber]
  );
  const { text, numbers } = paymentMethodFormatter(subProductType);
  return (
    <Modal
      className="history-modal"
      isVisible={isVisible}
      onClose={onClose}
      showCloseButton={false}
    >
      <div className={`${nsModal}__header`}>
        <h2>{`History log (${t(`product.${text}`, { number: numbers, x: numbers })})`}</h2>
      </div>
      <hr />
      <Box className="box">
        <>
          <div className={`${nsModal}__headers`}>
            <p>Order fee</p>
            <p>Service fee</p>
            <p>Start date</p>
          </div>
          <List
            data={historyList}
            component={PaymentHistoryItem}
            isLoading={loading}
            t={t}
          />
          <Pagination
            records={records}
            pageSize={pageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            changePageSize={setPageSize}
          />
        </>
      </Box>
    </Modal>
  );
};
